import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ApolloNeuro from "../pages/apollo-neuro/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/apollo-neuro",
    element: <ApolloNeuro />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;